import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { DistributorOutlet } from '@app/api/models/distributor';
import { booleanBodyRender, dateTimeBodyRender, TableColumn } from '@app/components/common/table';

export type DistributorOutletRow = DistributorOutlet & {
  distributor_name?: string;
  segment_name?: string;
};

const text = (value?: string | number | null) => (
  value === null || value === undefined || value === '' ? '—' : String(value)
);

export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: DistributorOutletRow) => void;
}): TableColumn<DistributorOutletRow>[] => [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'distributor_id',
    label: 'Дистрибьютор',
    options: {
      filter: {
        name: 'distributor_id',
        type: 'autocomplete',
        sourceName: 'distributor',
      },
      sort: true,
      customBodyRender: (_value, { rowData }) => {
        const name = rowData.distributor_name;
        return name ? `[${rowData.distributor_id}] ${name}` : `[${rowData.distributor_id}]`;
      },
    },
  },
  {
    name: 'distributor_outlet_id',
    label: 'Код клиента',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_outlet_id',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'distributor_outlet_name',
    label: 'Название',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_outlet_name',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'distributor_outlet_title',
    label: 'Вывеска',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_outlet_title',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'distributor_outlet_address',
    label: 'Адрес',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_outlet_address',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'distributor_outlet_inn',
    label: 'ИНН',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_outlet_inn',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'subnet',
    label: 'Подсеть',
    options: {
      filter: {
        type: 'text',
        name: 'subnet',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'status',
    label: 'Статус',
    options: {
      filter: {
        type: 'text',
        name: 'status',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'segment_id',
    label: 'Сегмент',
    options: {
      filter: {
        name: 'segment_id',
        type: 'select',
        sourceName: 'outlet_segment',
      },
      sort: true,
      customBodyRender: (_value, { rowData }) => (
        rowData.segment_name || (rowData.segment_id ? `[${rowData.segment_id}]` : '—')
      ),
    },
  },
  {
    name: 'route_number_id',
    label: 'Маршрут',
    options: {
      filter: {
        name: 'route_number_id',
        type: 'autocomplete-paginated',
        sourceName: 'route_number',
      },
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'outlet_id',
    label: 'ТТ SNEG',
    options: {
      filter: false,
      sort: true,
      customBodyRender: text,
    },
  },
  {
    name: 'open_date',
    label: 'Дата открытия',
    options: {
      filter: false,
      sort: true,
      customBodyRender: dateTimeBodyRender(false, true),
    },
  },
  {
    name: 'is_general',
    label: 'Основной',
    options: {
      filter: false,
      sort: false,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'is_active',
    label: 'Активна',
    options: {
      filter: false,
      sort: true,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'distributor_name',
    label: '',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_value, { rowData }) => (
        <Flex justifyContent="flex-end">
          <IconButton aria-label="edit" size="sm" onClick={() => onEdit(rowData)}>
            <MdEdit />
          </IconButton>
        </Flex>
      ),
    },
  },
];
